import React, { FC } from 'react';
import { FilesProvider } from '../../utils/hooks/useFiles';
import { Loader } from '../common/wixCommon';
import { EmptyStateServerError } from '../EmptyStates';
import styles from '../HomePage/HomePage.scss';
import { MyVideosContent } from '../MyVideosContent';
import { IOuter } from './MyVideosTab.types';

export const MyVideosTab: FC<IOuter> = ({
  requestError,
  isLoading,
  files,
  mediaToken,
  onGetVideoMakerItems,
}) => {
  return requestError ? (
    <EmptyStateServerError onActionButtonClick={onGetVideoMakerItems} />
  ) : isLoading ? (
    <div className={styles.loaderContainer} data-hook="my-videos-loader">
      <Loader />
    </div>
  ) : (
    <FilesProvider files={files}>
      <MyVideosContent mediaToken={mediaToken} />
    </FilesProvider>
  );
};
